const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "투명한 가격을 통해 정확한 계획을 선택하세요!",
  monthlyUppercase: "월간",
  montly: "월간",
  free: "무료",
  yearlyUppercase: "연간",
  yearly: "연간",
  inService: "서비스 중",
  buyBtn: "지금 구입",
  freeTips1: "최대 파일 크기 20MB 지원",
  freeTips2: "하루 6회 서류처리 기회",
  freeTips3: "정상 처리 속도",
  freeTips4: "정상 다운로드 속도",
  freeTips5: "하루에 한번 무료 그림배경 제거",
  freeTips52: "하루에 한번 무료 그림배경 제거",
  freeTips6: "모든 무료 툴에 액세스",
  vipTips1: "파일 크기 제한 없음",
  vipTips2: "일별 파일 제한 없음",
  vipTips3: "더 빠른 다운로드 속도",
  vipTips4: "더 빠른 처리 속도",
  vipTips5: "제한 없음",
  vipTips6: "무제한 이미지 배경 제거",
  vipTips7: "모든 도구 및 프리미엄 이용 기능",
  vipTips8: "자동으로 갱신하고 언제든지 취소 가능",
  vipTips9: "비디오 크기 및 수량 제한이 없습니다.",
  vipTips10: "제한 없이 이미지 배경을 제거할 수 있습니다.",
  vipTips11: "더 빠른 비디오 처리 및 다운로드 속도",
  vipTips12: "모든 무료 도구와 프리미엄 기능을 체험할 수 있습니다.",
  acceptTitle: "수락 가능",
  modalTitle: "모든 프리미엄 기능에 액세스하려면 Pro로 업그레이드하십시오.",
  total: "총가격",
  enterCode: "코드 입력",
  SignUpToPurchaseBtn: "등록하고 구입하기",
  purchaseBtn: "바로 구입",
  saveTips: "최대 {{num}}% 절약",
  discount: "할인",
  purchaseTips: "자동으로 갱신하면 언제든지 취소 가능합니다.",
  tips: "추가 정보:",
  promoCodeInvalidTips: "할인 코드가 잘못되었습니다.",
};

export default purchase;
